'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

export const avatar = css`
  --avatar-size: 50px;
  @media screen and (width > ${theme.sizes.screens.md}) {
    --avatar-size: 70px;
  }
`;

export const allButtons = css``;

export const toolbar = css`
  display: flex;
  justify-content: space-between;
  &.${allButtons} {
    flex-direction: column-reverse;
    @media screen and (width > ${theme.sizes.screens.md}) {
      flex-direction: initial;
    }
  }
`;

export const buttons = css`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  align-self: flex-start;
`;

export const walletBtn = css`
  &&& {
    color: ${theme.colors.peoople['azul-claro-medio']};
  }
`;

export const socialLogo = css`
  max-width: 100%;
`;

export const social = css`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  font-weight: 600;
  img {
    width: 29px;
    border-radius: 0.5rem;
    @media screen and (width > ${theme.sizes.screens.md}) {
      width: 26px;
    }
  }
  span {
    display: none;
    @media screen and (width > ${theme.sizes.screens.md}) {
      display: initial;
    }
  }
`;

export const personalInfo = css`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const nickname = css`
  font-weight: 700;
  font-size: 24px;
  word-break: break-all;
  line-height: 1em;
`;

export const name = css`
  color: ${theme.colors.peoople['gris-medio-claro']};
  font-weight: 500;
`;

export const details = css`
  display: flex;
  justify-content: space-between;
`;

export const network = css`
  display: flex;
  gap: 1rem;
`;

export const follows = css`
  font-weight: 500;
  line-height: 1em;
  color: ${theme.colors.peoople['gris-medio-claro']};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  b {
    color: ${theme.colors.peoople['gris-oscuro']};
    font-weight: 700;
  }
`;

export const links = css`
  display: flex;
  gap: 1rem;
  align-items: center;
`;
